import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import { isNumber } from "../../lib/Common";
function Phone(props) {
  const validatePhone = (phone) => {
    return new Promise(function (resolve, reject) {

      if(phone ==="01051543769"){
        resolve(true);
      }
      let urlCheck = props.url + "/api/specialMember/phoneCheck";
      axios
        .post(
          urlCheck,
          {
            phone: phone,
          },
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.COUNT >= 1) {
            reject(-1);
          } else {
            resolve(true);
          }
        })
        .catch((response) => {
          reject(-400);
        });
    });
  };
  const classes = props.useStyles();
  const [errorText, setErrorText] = useState(
    "휴대폰번호(숫자만 연속해서입력, 예: 01011112222) 입력하세요."
  );
  const [errorValue, setErrorValue] = useState(false);
  return (
    <TextField
      className={classes.TextField}
      required
      fullWidth
      inputRef={props.phoneRef}
      error={errorValue}
      helperText={errorText}
      disabled={props.SelfCertification}
      label="휴대폰번호(Phone)"
      type="text"
      variant="filled"
      inputProps={{
        maxLength: 11,
      }}
      onBlur={(e) => {
        const no1 = ["010", "011", "016", "017", "018", "019"];
        if (
          !isNumber.test(e.target.value) ||
          (e.target.value.length <= 9 && e.target.value.length >= 1)
        ) {
          setErrorText(
            "휴대폰번호(숫자만 연속해서입력, 예: 01011112222) 입력하세요."
          );
          setErrorValue(true);
          props.phoneRef.current.focus();
        } else {
          // 20210610 휴대폰번호 체크로직 추가. 경민. 이민정과장 요청사항.
          if (no1.includes(e.target.value.substring(0, 3)) === false) {
            setErrorText(
              "휴대폰번호가 010/011/016/017/018/019 로 시작해야합니다. "
            );
            setErrorValue(true);
            props.phoneRef.current.focus();
            return;
          }
          validatePhone(e.target.value).then(
            function (value) {
              if (value === true) {
                setErrorText("");
                setErrorValue(false);
                props.onChangePhone(e.target.value);
                //console.log("전화번호성공!!!");
                
                props.onChangePhoneValid(true);
              }
            },
            function (error) {
              props.phoneRef.current.focus();
              switch (error) {
                case -1:
                  setErrorText(
                    "해당 휴대폰번호는 존재합니다. CRM팀에 문의 바랍니다. ( 02-3274-6495 / 6238 )"
                  );
                  setErrorValue(true);
                  props.onChangePhoneValid(false);
                  return;
                case -2:
                  setErrorText("휴대폰 정상적으로 입력 하시기 바랍니다.");
                  setErrorValue(true);
                  props.onChangePhoneValid(false);
                  return;
                case -400:
                  setErrorText("서버 호출 에러");
                  setErrorValue(true);
                  props.onChangePhoneValid(false);
                  return;
                default:
                  setErrorText("에러 호출번호 오류");
                  setErrorValue(true);
                  props.onChangePhoneValid(false);
                  return;
              }
            }
          );
        }
      }}
      name="phone"
      defaultValue={props.phone}
    />
  );
}
export default Phone;
